import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=37b8ab69"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37b8ab69')) {
      api.createRecord('37b8ab69', component.options)
    } else {
      api.reload('37b8ab69', component.options)
    }
    module.hot.accept("./footer.vue?vue&type=template&id=37b8ab69", function () {
      api.rerender('37b8ab69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/core/footer.vue"
export default component.exports